module.exports = __webpack_public_path__ + "img/invisibility_cloak.dce89b7b.jpg";